import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=de129638&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=ts"
export * from "./Sample.vue?vue&type=script&lang=ts"
import style0 from "./Sample.vue?vue&type=style&index=0&id=de129638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de129638",
  null
  
)

export default component.exports